// Top-level admin home for Yabbit SMS gateway credentials + test-fire.
// Promoted out of the GymSales page (a back-link remains there).
import React from 'react';
import AdminLayout from './AdminLayout';
import YabbitSmsAdminCard from '../../components/yabbit-sms/YabbitSmsAdminCard';

export default function AdminYabbitSmsPage() {
  return (
    <AdminLayout>
      <div className="max-w-5xl space-y-4" data-testid="admin-yabbit-sms-page">
        <div>
          <h1 className="text-xl font-bold text-white">Yabbit SMS</h1>
          <p className="text-xs text-white/40">Per-tenant gateway credentials, sender IDs and simulated test sends.</p>
        </div>
        <YabbitSmsAdminCard />
      </div>
    </AdminLayout>
  );
}
